export default {"src":"/_next/static/media/grey-calendar.09fd9754.svg","height":16,"width":14};